import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path="/demo">
          <App />
        </Route>
        <Route exact path="/demo/oauth">
          <App initialPage="oauth" />
        </Route>
        <Redirect exact from="/home" to="/" />
        <Route path="/">
          <App initialPage="landingV2" />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);
